var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.021,
    height: 19.144,
    viewBox: "0 0 19.021 19.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share_icon",
    "data-name": "Share icon",
    transform: "translate(-1023.99 -652.99)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1814",
    "data-name": "Line 1814",
    y2: 11.722,
    transform: "translate(1033.505 653.99)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4785",
    "data-name": "Path 4785",
    d: "M2,3.844,7.545,9.388l5.544-5.841",
    transform: "translate(1025.959 656.472)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4786",
    "data-name": "Path 4786",
    d: "M17.522,6.239v5.788H.5V6.239",
    transform: "translate(1024.489 659.106)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDark);
export default __webpack_public_path__ + "static/media/Download-Dark.78715ec7402fa1d0fa79576fde36a95d.svg";
export { ForwardRef as ReactComponent };